import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbNavigationService, ConfigurationService, CoursesService, RestApiService } from '@draeger-academy/common';
import { CartService } from '@draeger-academy/common/lib/services/cart/cart.service';
import { GenericModalService } from '@draeger-academy/presentation/lib/modules/generic-modal';
import { TranslateService } from '@ngx-translate/core';
import { Course } from 'models/course';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ShowMoreComponent } from '../../../show-more/show-more.component';

@Component({
    selector: 'da-similar-courses',
    templateUrl: './similar-courses.component.html',
    styleUrls: ['./similar-courses.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SimilarCoursesComponent implements OnInit {
    @Input() public similarCourses: Course[] = [];
    public coursesFiltered = [];
    private _$similarCourses: BehaviorSubject<Course[]> = new BehaviorSubject([]);
    public get similarCourses$(): Observable<Course[]> {
        return this._$similarCourses.asObservable();
    }

    private _$showMoreInformation: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showMoreInformation$(): Observable<boolean> {
        return this._$showMoreInformation.asObservable();
    }
    @ViewChild('showMoreSection') showMoreSection: ShowMoreComponent;
    private innerScreenWidth: number;
    private _$coursesFilteredMore: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>(null);

    public get coursesFilteredMore$(): Observable<Course[]> {
        return this._$coursesFilteredMore.asObservable();
    }

    constructor(
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private _coursesService: CoursesService,
        private _restApiService: RestApiService,
        private _breadcrumbNavigationService: BreadcrumbNavigationService,
        private _configurationService: ConfigurationService,
        private _cartService: CartService,
        private _genericModalService: GenericModalService,
        private _translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this._$similarCourses.next(this.similarCourses);
        this.innerScreenWidth = window.innerWidth;
        let filteredMore = [];
        this.coursesFiltered = this.similarCourses.slice(0, 3);
        filteredMore = this.similarCourses.slice(3, this.similarCourses.length);
        this._$coursesFilteredMore.next(filteredMore);
    }

    public showMoreLink() {
        this.showMoreSection.onClick();
    }
    public showMore($event: boolean) {
        this._$showMoreInformation.next($event);
        localStorage.setItem('showMoreCourses', $event.toString());

        this.showMoreSection._$showMore.next($event);

        this.innerScreenWidth = window.innerWidth;

        // if (this.portal) {
        //     this._getPortalCourses(this.portal);
        // } else {
        //     this.getCourses();
        // }
    }
}
